<template>
  <div class="twitter-widget">
    <v-timeline
      :id="twitterId"
      :source-type="'profile'"
      :options="{ 'height': twitterHeight }"/>
  </div>
</template>

<script>
import {Timeline} from 'vue-tweet-embed'

export default {
  components: {
    'v-timeline': Timeline
  },
  data () {
    return {
      twitterId: 'A4_WORKS',
      twitterHeight: '400'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Twitter.vue